import { render, staticRenderFns } from "./SurveyTranslator.vue?vue&type=template&id=32afdfb4&scoped=true"
import script from "./SurveyTranslator.vue?vue&type=script&lang=js"
export * from "./SurveyTranslator.vue?vue&type=script&lang=js"
import style0 from "./SurveyTranslator.vue?vue&type=style&index=0&id=32afdfb4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32afdfb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32afdfb4')) {
      api.createRecord('32afdfb4', component.options)
    } else {
      api.reload('32afdfb4', component.options)
    }
    module.hot.accept("./SurveyTranslator.vue?vue&type=template&id=32afdfb4&scoped=true", function () {
      api.rerender('32afdfb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/SurveyTranslator.vue"
export default component.exports